import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { useAppStore } from '@/store'
import { boardLeft } from './utils/boardLeft'

/**
 * UI-84: drops a board that was created and never used, once the user leaves it.
 *
 * Mounted in RootLayout rather than in the board itself, because the board
 * canvas unmounts for reasons that are not a departure — StrictMode's effect
 * replay, and the gates above it swapping the tree out while auth or the board
 * loads. Hanging the delete off that unmount deleted boards out from under the
 * user seconds after they were created.
 *
 * A route change away from /board/:id is the actual event, and it cannot be
 * confused with a remount: the path does not change for one.
 */
const ProvisionalBoardSweeper = () => {
  const { pathname } = useLocation()
  const discardProvisionalBoard = useAppStore((s) => s.discardProvisionalBoard)
  const previousPathRef = useRef<string | null>(null)

  useEffect(() => {
    const from = previousPathRef.current
    previousPathRef.current = pathname
    const left = boardLeft(from, pathname)
    if (left) void discardProvisionalBoard(left)
  }, [pathname, discardProvisionalBoard])

  return null
}

export default ProvisionalBoardSweeper
